import api from '../api';

const teamService = {
    // List all teams the user belongs to
    list: (params) => api.get('/v1/teams', { params }),

    // Create a new team
    create: (payload) => api.post('/v1/teams', payload),

    // Get team details
    show: (id) => api.get(`/v1/teams/${id}`),

    // Update team
    update: (id, payload) => api.put(`/v1/teams/${id}`, payload),

    // Delete team
    remove: (id) => api.delete(`/v1/teams/${id}`),

    // Get team members
    members: (teamId) => api.get(`/v1/teams/${teamId}/members`),

    // Invite a member
    invite: (teamId, payload) => api.post(`/v1/teams/${teamId}/invite`, payload),

    // Accept an invitation
    acceptInvite: (token) => api.post(`/v1/invites/${token}/accept`),

    // Change member role
    changeRole: (teamId, userId, payload) => api.put(`/v1/teams/${teamId}/members/${userId}`, payload),

    // Remove a member
    removeMember: (teamId, userId) => api.delete(`/v1/teams/${teamId}/members/${userId}`),

    // Leave a team
    leave: (teamId) => api.post(`/v1/teams/${teamId}/leave`),

    // Transfer ownership
    transferOwnership: (teamId, payload) => api.post(`/v1/teams/${teamId}/transfer-ownership`, payload),

    // List invites for a team
    listInvites: (teamId, params) => api.get(`/v1/teams/${teamId}/invites`, { params }),

    // Resend an invitation
    resendInvite: (teamId, inviteId) => api.post(`/v1/teams/${teamId}/invites/${inviteId}/resend`),

    // Cancel/revoke an invitation
    cancelInvite: (teamId, inviteId) => api.delete(`/v1/teams/${teamId}/invites/${inviteId}`),
};

export default teamService;
